import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { ApmBase, init as initApm } from '@elastic/apm-rum';
import { useConfiguration } from './ConfigurationContext';

export const ApmContext = createContext<ApmBase | undefined>(undefined);

export function useApm() {
  return useContext(ApmContext);
}

export function ApmProvider({ children }: { children: ReactNode }) {
  const { elasticApmServerUrl, elasticApmEnvironment, elasticApmServiceVersion, elasticApmActive } =
    useConfiguration();

  const [apm, setApm] = useState<ApmBase>();

  useEffect(() => {
    if (
      !elasticApmServerUrl ||
      !elasticApmEnvironment ||
      !elasticApmServiceVersion ||
      !elasticApmActive
    ) {
      setApm(undefined);
      return;
    }

    try {
      setApm(
        initApm({
          serviceName: 'loyalty-gamification-frontend',
          serverUrl: elasticApmServerUrl,
          serviceVersion: elasticApmServiceVersion,
          environment: elasticApmEnvironment,
        }),
      );
    } catch (error) {
      console.error('Could not init apm', error);
    }
  }, [elasticApmServerUrl, elasticApmServiceVersion, elasticApmEnvironment]);

  return <ApmContext.Provider value={apm}>{children}</ApmContext.Provider>;
}
